<template>
  <div 
    id="login-person"
    @click.stop="toggleUserModal()"
  >
    <div class="std-spacing">{{ (userName) ? userName : 'Login' }}</div>
    <svg
      xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-circle std-spacing" viewBox="0 0 16 16">
      <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
      <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"/>
    </svg>
    <div
      id="user-modal"
      :class="{ 
        grow: showUserModal && !!userName,
        grow2: showUserModal && !userName,
      }"
      @click.stop=""
    >
      <!-- USER IS ALREADY LOGGED IN -->
      <div v-if="!!userName" id="logged-in-wrapper">

        <div class="FRNW">
          <ModernButtonVue
            :btnText="'Account'"
            :clickFunc="openAccountPage"
            :backgroundColor="'gainsboro'"
            :btnSize="'extra-small'"
            :showBorder="true"
            :hoverColor="'var(--fla-btn-hover-blue)'"
            :hoverFontColor="'white'"
          />

          <ModernButtonVue
            :btnText="'Log Out'"
            :clickFunc="logoutUser"
            :backgroundColor="'gainsboro'"
            :btnSize="'extra-small'"
            :showBorder="true"
            :hoverColor="'var(--fla-btn-hover-blue)'"
            :hoverFontColor="'white'"
          />
        </div>

        <div 
          v-if="userOfLab"
          class="FRNW toggle-switch-wrapper"
        >
          <label class="toggle-switch" style="margin-right:.35rem;">
            <input 
              type="checkbox" 
              v-model="showLabOrders"
              @change="toggleShowLabOrders"
            >
            <span class="slider"></span>
          </label>
          <span>Show Lab Orders?</span>
        </div>
      </div>

      

      <!-- USER NEEDS TO LOG IN -->
      <div v-else id="not-logged-in-wrapper">
        <input name="fla-user-email" key="fla-user-email" type="text" placeholder="email" v-model="userEmail">
        <input type="password" placeholder="password" v-model="pw">
        
        <div id="login-button-wrapper">
          <ModernButtonVue
            :btnText="'Login'"
            :disabled="!canSubmit"
            :clickFunc="userLogin"
            :backgroundColor="'gainsboro'"
            :btnSize="'extra-small'"
            :showBorder="true"
            :hoverColor="'var(--fla-btn-hover-blue)'"
            :hoverFontColor="'white'"
          />
          <ModernButtonVue
            :btnText="'Create User'"
            :clickFunc="openCreateUserPage"
            :backgroundColor="'gainsboro'"
            :btnSize="'extra-small'"
            :showBorder="true"
            :hoverColor="'var(--fla-btn-hover-blue)'"
            :hoverFontColor="'white'"
          />        
        </div>
        <ModernButtonVue
          :btnText="'Forgot Password'"
          :disabled="!validEmail"
          :backgroundColor="'gainsboro'"
          :btnSize="'extra-small'"
          :showBorder="true"
          :hoverColor="'var(--fla-btn-hover-blue)'"
          :hoverFontColor="'white'"
          :clickFunc="forgotPassword"
        />
        
      </div>

    </div>
  </div>
</template>


<script>


// GLOBALS
// ----------------
const API = process.env.VUE_APP_API_URL;
const LOCAL_STORAGE_KEY = 'FLA_SHOW_LAB_ORDERS';
let FLA_AXIOS
// ----------------

import { ValidateEmail, RemoveLocalStorageKeys, LocalStorageFuncs } from '../../utils';
import router from '../../router/index.js';
import ModernButtonVue from './ModernButton.vue';
import VueCookies from 'vue-cookies';


export default {
  name:'LoginPerson',
  components: {
    ModernButtonVue,
  },
  props:{
    loginCb: Function,
    logoutCb: Function,
    labOrdersUpdateCb: Function,
  },
  data() {
    return {
      userName: '',
      userEmail: '',
      pw: '',
      showUserModal: false,
      showLabOrders: false,
    }
  },
  computed: {
    canSubmit() {
      return this.pw !== '' && ValidateEmail( this.userEmail );
    },

    validEmail() {
      return ValidateEmail( this.userEmail );
    },
  },
  methods: {

    userModalToggle( val ) {
      this.showUserModal = val;
      // TODO: remove this method
    },

    toggleUserModal() {
      this.showUserModal = !this.showUserModal
    },

    toggleShowLabOrders() {
      this.labOrdersUpdateCb();
      
      const showLabOrders = localStorage.getItem(LOCAL_STORAGE_KEY);
      const newVal = ( !showLabOrders || showLabOrders === 'false')
        ? 'true'
        : 'false';
      localStorage.setItem('FLA_SHOW_LAB_ORDERS', newVal)
    },

    setShowLabOrders() {
      const showLabOrders = localStorage.getItem(LOCAL_STORAGE_KEY);
      this.showLabOrders = ( showLabOrders === 'true' )
        ? true
        : false;
    },

    userLogin() {
      const data = {
        email: this.userEmail,
        pw: this.pw
      };

      this.axios
        .post( API + '/api/user/login', data )
        .then( res => {
          const { userName, FLA_token, FLA_u_id } = res.data;
          if ( userName ) this.userName = userName;
          this.showNotification( res.data, 10 );

          // set storage items
          LocalStorageFuncs.setUserId( FLA_u_id );
          LocalStorageFuncs.setToken( FLA_token );

          // // for a test cookie
          // document.cookie = "username=John Smith; expires=Sat, 31 Aug 2024 12:00:00 UTC;";

          // // Using vue-cookies
          // VueCookies.set('FLA_u_id', FLA_u_id);
          // VueCookies.set('FLA_token', FLA_token);

          // reset input info - mm 080724: pretty sure this isn't needed anymore
          if ( res.data?.notification?.type !== 'error' ) {
            this.email = '';
            this.pw = '';
          }
          
          if ( this.loginCb ) this.loginCb();
        } )
        .catch( e => console.error(e) );

    }, 

    fetchUserName() {
      const token = LocalStorageFuncs.fetchToken();

      this.axios
        .get( API + '/api/user/fetchUser/' + token )
        .then( res =>{
          const { userName, userId, userOfLab } = res.data;

          this.userName = userName;
          this.userOfLab = userOfLab;

          // if no user name then local storage is invalid, clear it
          if ( !userName ) {
            this.logoutUser( false );
            return;
          }

          if ( !LocalStorageFuncs.fetchUserId() ) {
            LocalStorageFuncs.setUserId( userId );
          }
        } )
        .catch( e => console.error(e) );
    },

    async logoutUser( forceNotification=true ) {

      // remove all FLA related cookies
      // // I dont think this is needed since we aren't storing user data in the cookies anymore
      // await FLA_AXIOS('post', API + '/api/user/logout');

      // clear local variables
      RemoveLocalStorageKeys();

      // reset userName value
      this.userName = '';

      // force a notification
      if ( forceNotification ) {
        this.showNotification( { notification: {
          msg: 'User has been logged out.'
        } } );
      }

      if ( this.logoutCb ) this.logoutCb();

      // if not on home page, redirect
      const { pathName } = window.location;
      if ( pathName !== '/' ) {
        setTimeout(() => {
          router.push('/');
        }, 250);
      }
    },

    openAccountPage() {
      router.push( '/userAccount');
      return;
    },

    openCreateUserPage() {
      router.push( '/createUser');
      return;
    },

    forgotPassword() {
      const email = this.userEmail;
      const data = { email };

      FLA_AXIOS('post', API + '/api/user/forgotPassword', data )
      .then( res => {
        this.showNotification( res.data );
      })
      .catch( e => console.error(e) )
    },

    // TODO: is there a better way to reach the notification component?
    showNotification( data, sec ) {
      window?.showNotification( data, sec );
    }

  },
  mounted(){
    this.fetchUserName();
    this.setShowLabOrders();
    FLA_AXIOS = window.FLA_Axios;
  }
}
</script>


<style>

#nav-bar-container {
  display: flex;
  height: 3rem;
  background-color: rgb(220, 220, 220);
  border: 2px solid black;
  justify-content: space-evenly;
  align-items: center;
  box-sizing: border-box;
}

#user-modal {
  background-color: var(--fla-gray);
  position: absolute;
  width: 13rem;
  height: 0rem;
  transition: all .3s;
  top: 2rem;
  right: 0rem;
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 10px;
  justify-content: space-around;
  display: flex;
}

 #user-modal.grow {
  height: 5rem;
  border: 1px solid black;
 }

 #user-modal.grow2 {
  height: 7rem;
  border: 1px solid black;
 }

#login-person {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  transition: all .3s;
}

#login-person:hover {
  background-color: blanchedalmond;
  background-color: var(--fla-gray);
}

.std-spacing {
  padding: .25rem;
  margin: .15rem;
}

#login-button-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#login-button-wrapper button {
  margin-left: .5rem;
  margin-right: .5rem;
}

button:not(:disabled) {
  cursor: pointer;
  margin: .25rem;
}

#logged-in-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
}

/* Toggle button styling */
/* --------------------- */
.toggle-switch-wrapper {
  align-items: center;
  justify-content: center;
}
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 2rem;
  height: 1rem;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.3s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 1.2rem;
  width: 1.2rem;
  left: -.2rem;
  bottom: -.1rem;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: var(--fla-button-blue);
}

input:checked + .slider:before {
  transform: translateX(1.2rem);
}
/* --------------------- */

</style>